module.exports = __webpack_public_path__ + "static/media/27.6c845881.jpg";